import { useCallback, useEffect, useState } from "react";

import AdminUserTable from "./AdminUserTable";
import AdminUserInviteModal from "./AdminUserInviteModal";
import AdminUserPasswordModal from "./AdminUserPasswordModal";
import AdminUserEditModal from "./AdminUserEditModal";
import AdminUserAddModal from "./AdminUserAddModal";

import { IWilmaUser } from "../../models/auth/WilmaUser";

import useWilmaUsers from "../../data/useWilmaUsers";
import LoadingWheel from "../shared/LoadingWheel";
import { EnvelopeIcon, PlusSmallIcon } from "@heroicons/react/20/solid";

export default function AdminUsers() {
    const { wilmaUsers } = useWilmaUsers();
    const [users, setUsers] = useState<IWilmaUser[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    const [open, setOpen] = useState(false);
    const [addOpen, setAddOpen] = useState(false);
    const [passwordOpen, setPasswordOpen] = useState(false);
    const [passwordUser, setPasswordUser] = useState<IWilmaUser | undefined>(undefined);
    const [editOpen, setEditOpen] = useState(false);
    const [editUser, setEditUser] = useState<IWilmaUser | undefined>(undefined);

    const handleInviteUser = () => {
        setOpen(true);
    }

    const handleChangePassword = useCallback((user: IWilmaUser) => {
        setPasswordUser(user);
        setPasswordOpen(true);
    }, []);

    const handleEdit = useCallback((user: IWilmaUser) => {
        setEditUser(user);
        setEditOpen(true);
    }, []);

    useEffect(() => {
        if (wilmaUsers.data && !wilmaUsers.isLoading) {
            setIsLoading(false);
            setUsers(wilmaUsers.data.data);
        }
    }, [wilmaUsers.data, wilmaUsers.isLoading]);

    if(isLoading) return <LoadingWheel />

    return (
        <div>
            <AdminUserInviteModal open={open} setOpen={setOpen} />
            <AdminUserAddModal open={addOpen} setOpen={setAddOpen} />
            <AdminUserPasswordModal open={passwordOpen} setOpen={setPasswordOpen} user={passwordUser} />
            <AdminUserEditModal open={editOpen} setOpen={setEditOpen} user={editUser} />
            <h1 className="mb-2">Admin Users</h1>
            <div className="flex gap-2">
                <button
                    className=" bg-primary-600 hover:bg-primary-700 inline-flex items-center rounded-md border border-transparent px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm"
                    type="button"
                    onClick={() => setAddOpen(true)}
                >
                    <PlusSmallIcon className="h-5 w-5 mr-2" />
                    Add User
                </button>
                <button
                    className=" bg-primary-600 hover:bg-primary-700 inline-flex items-center rounded-md border border-transparent px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm"
                    type="button"
                    onClick={() => handleInviteUser()}
                >
                    <EnvelopeIcon className="h-5 w-5 mr-2" />
                    Invite User
                </button>
            </div>
            <AdminUserTable users={users} onEdit={handleEdit} onChangePassword={handleChangePassword} />
        </div>
    )
}